export enum FEATURE_FLAGS {
  SOME_TEST_FLAG = 'some-test-flag',
  RFIS_FE_DUE_DATE_TO_APPLY_PROJECT_TZ_FROM = 'rfis-fe-due-date-to-apply-project-tz-from',
  MAINTENANCE_MODE = 'ab-rfis-maintenance-mode',
  EXTERNAL_ID_FILTER = 'ab-rfis-external-id-filter',
  CO_REVIEWERS = 'ab-rfis-co-reviewers',
  DEFAULT_CUSTOM_ATTRIBUTES = 'ab-rfis-default-custom-attributes',
  LIB_MANAGE_FIELDS = 'ab-rfis-lib-manage-fields',
  OPTIONAL_REVIEWERS = 'ab-rfis-optional-reviewers',
  ROLES_AND_COMPANIES_AS_BIC = 'rfis-roles-and-companies-as-bic',
}

export const DEFAULT_FEATURE_FLAGS_VALUES: { [key in FEATURE_FLAGS]: boolean | number } = {
  [FEATURE_FLAGS.SOME_TEST_FLAG]: 100,
  [FEATURE_FLAGS.RFIS_FE_DUE_DATE_TO_APPLY_PROJECT_TZ_FROM]: 4095742606000, // timestamp of Thursday, October 15, 2099 1:16:46 PM GMT+03:00
  [FEATURE_FLAGS.MAINTENANCE_MODE]: false,
  [FEATURE_FLAGS.EXTERNAL_ID_FILTER]: false,
  [FEATURE_FLAGS.CO_REVIEWERS]: true,
  [FEATURE_FLAGS.DEFAULT_CUSTOM_ATTRIBUTES]: false,
  [FEATURE_FLAGS.LIB_MANAGE_FIELDS]: false,
  [FEATURE_FLAGS.OPTIONAL_REVIEWERS]: false,
  [FEATURE_FLAGS.ROLES_AND_COMPANIES_AS_BIC]: false,
};
